export default "__VITE_ASSET__4d7b9745__"